import { render, staticRenderFns } from "./ExtraResourcesAlertModal.vue?vue&type=template&id=06a83487&"
import script from "./ExtraResourcesAlertModal.vue?vue&type=script&lang=js&"
export * from "./ExtraResourcesAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports